import { get, post } from './baseAxios';
import { API_ASSIGNED_USER_CONTACTS } from '../utils/urls';

const url = API_ASSIGNED_USER_CONTACTS;

export const filter = (params) => get(url, { params });

export const assign = (request) => post(`${url}/assign`, request);
